module.exports = __webpack_public_path__ + "static/media/multicolli.bb54fc70.png";